import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

import { desktop } from './check-res'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('load', () => {
	if (desktop) {
		const stickers = document.querySelectorAll('[data-sticker]')
		const stickersLeft = document.querySelectorAll('[data-sticker="left"]')
		const stickersRight = document.querySelectorAll('[data-sticker="right"]')

		stickersRight.forEach((sticker) => {
			gsap.set(sticker, {
				scale: 4,
				translateX: '70vw',
			})
		})

		stickersLeft.forEach((sticker) => {
			gsap.set(sticker, {
				scale: 4,
				translateX: '-70vw',
			})
		})

		stickers.forEach((sticker) => {
			gsap
				.timeline({
					defaults: {
						ease: 'power4.out',
						duration: 1,
					},
					scrollTrigger: {
						trigger: sticker,
						start: 'center 75%',
					},
				})
				.to(
					sticker,
					{
						translateX: 0,
					},
					0
				)
				.to(
					sticker,
					{
						scale: 1,
					},
					'<'
				)
		})
	}
})
